import type { LeadWithValuation } from '@/types'
import { LEAD_COLUMNS, leadToRow, exportFileName, downloadBlob } from './common'

export function exportCSV(leads: LeadWithValuation[]) {
  const headers = LEAD_COLUMNS.map(c => c.header)
  const rows = leads.map(leadToRow)

  const csvContent = [
    headers.join(';'),
    ...rows.map(row => row.join(';')),
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  downloadBlob(blob, exportFileName('leads', 'csv'))
}
